import { createControlComponent } from './core';
import L from '@anlan/gs-map';
import type { Control as LeafletControl, ControlOptions } from '@anlan/gs-map';
const Control = L.Control;
export const AttributionControl = createControlComponent(function createAttributionControl(props: ControlOptions): LeafletControl {
    return new Control.Attribution(props);
});
